import React, { CSSProperties, FC, MouseEvent, ReactNode, RefObject } from 'react';
import cn from 'classnames';
require("./Tab.css");
var styles = {
  "Root": "Tab-module-Root_Sez",
  "Disabled": "Tab-module-Disabled_1DD",
  "SelectedDefault": "Tab-module-SelectedDefault_3PN",
  "SelectedDefaultDisabled": "Tab-module-SelectedDefaultDisabled_2X1",
  "SelectedColourful": "Tab-module-SelectedColourful_35P",
  "SelectedColourfulDisabled": "Tab-module-SelectedColourfulDisabled_36k"
};
import { ITabsVariants } from '../Tabs';
export const Tab = ({
  innerRef,
  controlRef,
  ariaControls,
  children = '',
  className,
  isActive = false,
  isDisabled = false,
  index = 0,
  onClick,
  style,
  variant = 'filledBg'
}) => {
  return /*#__PURE__*/React.createElement("button", {
    ref: innerRef || controlRef,
    className: cn(styles.Root, className, {
      [styles.Disabled]: isDisabled,
      [styles.SelectedDefault]: isActive && !isDisabled && ['filled', 'filledBg'].includes(variant),
      [styles.SelectedColourful]: isActive && !isDisabled && variant === 'underlined',
      [styles.SelectedDefaultDisabled]: isActive && isDisabled && ['filled', 'filledBg'].includes(variant),
      [styles.SelectedColourfulDisabled]: isActive && isDisabled && variant === 'underlined'
    }),
    tabIndex: isActive ? 0 : -1,
    "aria-controls": ariaControls,
    "aria-selected": isActive,
    onClick: onClick,
    role: "tab",
    style: style,
    "data-index": index,
    disabled: isDisabled
  }, children);
};